import React from "react";
import styled from "styled-components";
import Breadcrumb from "sushiweb/Breadcrumb";
import Button from "sushiweb/Button";
import Back from "sushiweb/Icons/all/Back";
import Permission from "../../components/Common/Permission";
import {
  Divider,
  FieldsContainer,
  FieldsSection,
  FlexContainer,
} from "../../constants/assets/containers";
import variables from "../../constants/assets/variables";
import { isMobile, isValidated, isValNull } from "../../utils";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { useParams, useHistory } from "react-router-dom";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../components/Common/PaginatedReactDropdown";
import Textarea from "sushiweb/InputTypes/Textarea";
import ToggleSwitch from "../../components/Common/ToggleSwitch";
import fieldsState from "./fieldState.json";
import InfiniteScrollDropdown from "../../components/Common/InfiniteScrollDropdown";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as SubIssueTypeActions from "../../store/actions/SubIssueTypes";
import * as UserActions from "../../store/actions/User";
import PlusCircle from "sushiweb/Icons/all/PlusCircle";
import CrossCircle from "sushiweb/Icons/all/CrossCircle";
import * as IssueTypesActions from "../../store/actions/IssueTypes";
import MultiSelectDropdown from "../../components/Common/MultiSelectDropdown";

const mandatoryFieldsToCheck = ["name", "externalMappingName", "issueId"];

const SubIssueTypeAction = (props) => {
  const {
    saveUpdateSubIssueTypes,
    getSubIssueTypesDetails,
    subIssueTypeDetails,
    getIssueTypeRemoteSearch,
    remoteSearch,
    currentPage,
    activeFilters,
    getSubIssueTypesList,
    setStatus,
    getIssueTypeList,
    getIssueArea,
  } = props;

  const [enabledIssueTypeIds, setEnabledIssueTypeIds] = React.useState(
    new Set()
  );
  const history = useHistory();

  const { id, action } = useParams();

  const isCreateMode = history.location.pathname === "/sub-issue-types/create";
  const actionType = isCreateMode ? "create" : action;
  const subIssueId = isCreateMode ? null : id;
  const allActions = MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD];
  const [inputFieldState, setInputFieldState] = React.useState(fieldsState);
  const [conditionsList, setConditionsList] = React.useState([]);
  const [priorityFlag, setPriorityFlag] = React.useState(true);
  const textareaRef = React.useRef(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const issueTypesFetchedRef = React.useRef(false);
  const [visibilityOptions, setVisibilityOptions] = React.useState([]);
  const [conditionsConfig, setConditionsConfig] = React.useState([]);

  const languages = [
    { code: "en", label: "English (en)" },
    { code: "hi", label: "Hindi (hi)" },
    { code: "ta", label: "Tamil (ta)" },
    { code: "te", label: "Telugu (te)" },
    { code: "kn", label: "Kannada (kn)" },
    { code: "bn", label: "Bengali (bn)" },
  ];

  const booleanOptions = [
    { key: true, label: "true" },
    { key: false, label: "false" },
  ];

  React.useEffect(() => {
    if (!conditionsConfig.length || !visibilityOptions.length) {
      console.log("Fetching issue areas and condition configurations...");
      getIssueArea()
        .then((response) => {
          if (response && response.visibilityTags) {
            setVisibilityOptions(response.visibilityTags);
          }

          if (response && response.conditions) {
            setConditionsConfig(response.conditions);
          }

          console.log("API configuration loaded successfully");
        })
        .catch((err) => {
          console.error("Failed to fetch configurations:", err);
          setStatus({
            type: "error",
            message:
              "Failed to load issue configurations. Please refresh the page.",
          });
        });
    }
  }, [getIssueArea, setStatus]);

  const validateConditions = (conditions) => {
    let errors = [];
    if (!Array.isArray(conditions)) {
      errors.push("Conditions must be an array.");
      return errors;
    }

    conditions.forEach((item, index) => {
      if (typeof item !== "object" || item === null) {
        errors.push(`Condition at index ${index} must be an object.`);
      } else if (!item.hasOwnProperty("key") || !item.hasOwnProperty("value")) {
        errors.push(
          `Condition at index ${index} must have "key" and "value" properties.`
        );
      } else {
        const key = item.key;
        const value = item.value;

        if (!key || key.trim() === "") {
          errors.push(`Condition at index ${index} has an empty key.`);
          return;
        }

        const configItem = conditionsConfig.find((c) => c.name === key);
        if (!configItem) {
          errors.push(`Invalid condition field: ${key}.`);
        } else {
          const dataType = configItem.data_type;

          if (dataType === "bool") {
            if (typeof value !== "boolean") {
              errors.push(
                `Value for key "${key}" at index ${index} must be a boolean (true or false without quotes).`
              );
            }
          } else if (dataType === "string") {
            if (typeof value !== "string") {
              errors.push(
                `Value for key "${key}" at index ${index} must be a string (with quotes).`
              );
            } else if (value.trim() === "") {
              errors.push(
                `Value for key "${key}" at index ${index} cannot be empty.`
              );
            }

            if (configItem.valid_values && configItem.valid_values.length > 0) {
              if (!configItem.valid_values.includes(value)) {
                errors.push(
                  `Value "${value}" for key "${key}" at index ${index} is not in the list of valid values.`
                );
              }
            }
          } else if (dataType === "[]string") {
            if (!Array.isArray(value)) {
              errors.push(
                `Value for key "${key}" at index ${index} must be an array.`
              );
            } else if (value.length === 0) {
              errors.push(
                `Value for key "${key}" at index ${index} cannot be an empty array.`
              );
            } else {
              value.forEach((el, i) => {
                if (typeof el !== "string") {
                  errors.push(
                    `Element at position ${i} for key "${key}" at index ${index} must be a string.`
                  );
                } else if (el.trim() === "") {
                  errors.push(
                    `Element at position ${i} for key "${key}" at index ${index} cannot be empty.`
                  );
                }
                if (
                  configItem.valid_values &&
                  configItem.valid_values.length > 0
                ) {
                  if (!configItem.valid_values.includes(el)) {
                    errors.push(
                      `Value "${el}" for key "${key}" at index ${index} is not in the list of valid values.`
                    );
                  }
                }
              });
            }
          }
        }
      }
    });

    return errors;
  };

  const transformConditionsToV2 = (conditions) => {
    const conditionsV2 = [];

    conditions.forEach((condition) => {
      const { key, value } = condition;

      if (!key || key.trim() === "") {
        return;
      }

      const configItem = conditionsConfig.find((c) => c.name === key);
      if (!configItem) return;

      const dataType = configItem.data_type;

      if (
        (dataType === "string" && (value === "" || value.trim() === "")) ||
        (dataType === "[]string" &&
          Array.isArray(value) &&
          value.length === 0) ||
        value === undefined ||
        value === null
      ) {
        return;
      }

      const conditionObj = {};
      conditionObj[key] = value;
      conditionsV2.push(conditionObj);
    });

    return conditionsV2;
  };

  const handleAddCondition = () => {
    const hasEmptyCondition = conditionsList.some((condition) => {
      return !condition.key || condition.key.trim() === "";
    });

    if (hasEmptyCondition) {
      setStatus({
        type: "error",
        message: "Please select a condition key before adding a new condition.",
      });
      return;
    }

    const hasIncompleteCondition = conditionsList.some((condition) => {
      if (condition.key && condition.key.trim() !== "") {
        const configItem = conditionsConfig.find(
          (c) => c.name === condition.key
        );
        if (!configItem) return false;
        const dataType = configItem.data_type;

        if (dataType === "bool" && typeof condition.value !== "boolean") {
          return true;
        }

        if (
          dataType === "string" &&
          (condition.value === undefined ||
            condition.value === null ||
            condition.value.trim() === "")
        ) {
          return true;
        }

        if (
          dataType === "[]string" &&
          (!Array.isArray(condition.value) || condition.value.length === 0)
        ) {
          return true;
        }
      }

      return false;
    });

    if (hasIncompleteCondition) {
      setStatus({
        type: "error",
        message:
          "Please complete all current conditions before adding a new one.",
      });
      return;
    }

    setConditionsList([
      ...conditionsList,
      {
        key: "",
        value: "",
      },
    ]);
  };

  const handleRemoveCondition = (index) => {
    const updatedConditions = [...conditionsList];
    updatedConditions.splice(index, 1);
    setConditionsList(updatedConditions);

    setInputFieldState((prevState) => ({
      ...prevState,
      conditions: JSON.stringify(updatedConditions),
    }));
  };

  const handleConditionChange = (index, field, value) => {
    const updatedConditions = [...conditionsList];

    if (field === "key") {
      if (arrayInputState[index]) {
        setArrayInputState((prev) => {
          const newState = { ...prev };
          delete newState[index];
          return newState;
        });
      }

      const configItem = conditionsConfig.find((c) => c.name === value);
      if (!configItem) return;

      const dataType = configItem.data_type;

      updatedConditions[index] = {
        key: value,
        value: dataType === "bool" ? false : dataType === "[]string" ? [] : "",
      };
    } else {
      const configItem = conditionsConfig.find(
        (c) => c.name === updatedConditions[index].key
      );
      if (!configItem) return;

      const dataType = configItem.data_type;

      if (dataType === "bool") {
        updatedConditions[index].value = value === true || value === "true";
      } else if (dataType === "[]string") {
        if (Array.isArray(value)) {
          updatedConditions[index].value = value;
        } else if (typeof value === "string" && value.includes(",")) {
          updatedConditions[index].value = value
            .split(",")
            .map((item) => item.trim())
            .filter((item) => item !== "");
        } else if (typeof value === "string") {
          updatedConditions[index].value = value.trim() ? [value.trim()] : [];
        }
      } else {
        updatedConditions[index].value = value;
      }
    }

    setConditionsList(updatedConditions);

    setInputFieldState((prevState) => ({
      ...prevState,
      conditions: JSON.stringify(updatedConditions),
    }));
  };

  const [arrayInputState, setArrayInputState] = React.useState({});

  const getConditionKeyOptions = () => {
    return conditionsConfig.map((condition) => ({
      key: condition.name,
      label: `${condition.name} (${condition.data_type})`,
      dataType: condition.data_type,
      validValues: condition.valid_values || [],
    }));
  };

  const renderValue = (condition, index) => {
    const configItem = conditionsConfig.find((c) => c.name === condition.key);
    if (!configItem) return null;

    const dataType = configItem.data_type;
    const validValues = configItem.valid_values || [];

    if (dataType === "bool") {
      if (checkDisabledField()) {
        return (
          <Input
            value={condition.value === true ? "true" : "false"}
            data-testid={`conditionValueText-${index}`}
            id="sushi-input"
            disabled={true}
            label="Value"
            innerWidth="70%"
          />
        );
      }
      const selectedOption = booleanOptions.find(
        (option) => option.key === condition.value
      );

      return (
        <PaginatedReactDropdown
          options={booleanOptions}
          data-testid={`conditionValueDropdown-${index}`}
          labelKey="label"
          valueKey="key"
          disabled={false}
          value={selectedOption?.label || ""}
          handleChange={(key, val) =>
            handleConditionChange(index, "value", val)
          }
          keyToChange="value"
          placeholder="Value"
          showCross={false}
          id={`conditionValueDropdown-${index}`}
          width="50%"
          labelWidth="auto"
        />
      );
    } else if (dataType === "[]string") {
      if (checkDisabledField()) {
        return (
          <Input
            value={
              Array.isArray(condition.value) ? condition.value.join(", ") : ""
            }
            data-testid={`conditionValueText-${index}`}
            id="sushi-input"
            disabled={true}
            label="Value"
            innerWidth="70%"
          />
        );
      }

      if (validValues && validValues.length > 0) {
        const options = validValues.map((val) => ({
          key: val,
          label: val,
        }));

        const selectedValues = Array.isArray(condition.value)
          ? condition.value.map((val) => ({
              key: val,
              label: val,
            }))
          : [];

        return (
          <MultiSelectDropdown
            options={options}
            data-testid={`conditionValueMultiSelect-${index}`}
            labelKey="label"
            valueKey="key"
            disabled={false}
            value={selectedValues}
            handleChange={(key, vals) => {
              const selectedVals = Array.isArray(vals)
                ? vals.map((v) => v.key || v)
                : [];
              handleConditionChange(index, "value", selectedVals);
            }}
            keyToChange="value"
            placeholder="Select values"
            showCross={true}
            id={`conditionValueMultiSelect-${index}`}
            width="70%"
            labelWidth="auto"
            isMulti={true}
          />
        );
      } else {
        const inputValue =
          arrayInputState[index] !== undefined
            ? arrayInputState[index]
            : Array.isArray(condition.value)
            ? condition.value.join(", ")
            : "";
        return (
          <Input
            value={inputValue}
            data-testid={`conditionValueInput-${index}`}
            id="sushi-input"
            onChange={(e) => {
              setArrayInputState((prev) => ({ ...prev, [index]: e }));

              if (e.includes(",")) {
                const arrayValue = e
                  .split(",")
                  .map((item) => item.trim())
                  .filter((item) => item !== "");

                handleConditionChange(index, "value", arrayValue);
              } else {
                handleConditionChange(
                  index,
                  "value",
                  [e.trim()].filter((item) => item !== "")
                );
              }
            }}
            disabled={checkDisabledField()}
            label="Value (comma-separated)"
            innerWidth="70%"
            placeholder="Enter values separated by commas"
          />
        );
      }
    } else if (dataType === "string") {
      if (checkDisabledField()) {
        return (
          <Input
            value={condition.value}
            data-testid={`conditionValueText-${index}`}
            id="sushi-input"
            disabled={true}
            label="Value"
            innerWidth="70%"
          />
        );
      }

      if (validValues && validValues.length > 0) {
        const options = validValues.map((val) => ({
          key: val,
          label: val,
        }));

        return (
          <PaginatedReactDropdown
            options={options}
            data-testid={`conditionValueDropdown-${index}`}
            labelKey="label"
            valueKey="key"
            disabled={false}
            value={condition.value}
            handleChange={(key, val) =>
              handleConditionChange(index, "value", val)
            }
            keyToChange="value"
            placeholder="Select value"
            showCross={false}
            id={`conditionValueDropdown-${index}`}
            width="70%"
            labelWidth="auto"
          />
        );
      } else {
        return (
          <Input
            value={condition.value}
            data-testid={`conditionValueInput-${index}`}
            id="sushi-input"
            onChange={(e) => handleConditionChange(index, "value", e)}
            disabled={checkDisabledField()}
            label="Value"
            innerWidth="70%"
          />
        );
      }
    }

    return null;
  };

  const getFilteredConditionOptions = (currentIndex) => {
    const conditionOptions = getConditionKeyOptions();

    const usedKeys = conditionsList.reduce((keys, condition, index) => {
      if (
        index !== currentIndex &&
        condition.key &&
        condition.key.trim() !== ""
      ) {
        keys.push(condition.key);
      }
      return keys;
    }, []);

    return conditionOptions.filter((option) => !usedKeys.includes(option.key));
  };

  React.useEffect(() => {
    const fetchAllIssueTypes = async () => {
      if (issueTypesFetchedRef.current) {
        console.log("Issue types already fetched, skipping...");
        return;
      }

      try {
        console.log("Starting to fetch all issue types");

        let allIssueTypes = [];
        let currentPage = 1;
        let hasMore = true;

        while (hasMore) {
          console.log(`Fetching issue types page ${currentPage}`);
          const response = await getIssueTypeList(currentPage, {});

          if (response?.data && Array.isArray(response.data)) {
            allIssueTypes = [...allIssueTypes, ...response.data];
            console.log(
              `Added ${response.data.length} issue types, total: ${allIssueTypes.length}`
            );

            if (
              response.PageResponse &&
              response.PageResponse.nextPage !== -1
            ) {
              currentPage = response.PageResponse.nextPage;
            } else {
              hasMore = false;
            }
          } else {
            hasMore = false;
          }
        }

        console.log(`Fetched a total of ${allIssueTypes.length} issue types`);

        const enabledIds = new Set(
          allIssueTypes
            .filter((item) => item.enabled === true || item.enabled === "true")
            .map((item) => String(item.id))
        );

        console.log(`Found ${enabledIds.size} enabled issue types`);
        setEnabledIssueTypeIds(enabledIds);

        localStorage.setItem(
          "enabledIssueTypeIds",
          JSON.stringify([...enabledIds])
        );
        localStorage.setItem(
          "issueTypesFetchedTimestamp",
          Date.now().toString()
        );

        issueTypesFetchedRef.current = true;
      } catch (err) {
        console.error("Error fetching all issue types:", err);
      }
    };

    const cachedTimestamp = localStorage.getItem("issueTypesFetchedTimestamp");
    const currentTime = Date.now();
    const oneMinInMs = 60 * 1000;

    if (
      cachedTimestamp &&
      currentTime - parseInt(cachedTimestamp) < oneMinInMs
    ) {
      try {
        const cachedEnabledIds = JSON.parse(
          localStorage.getItem("enabledIssueTypeIds")
        );
        if (cachedEnabledIds && cachedEnabledIds.length > 0) {
          console.log(
            `Using ${cachedEnabledIds.length} cached enabled issue types`
          );
          setEnabledIssueTypeIds(new Set(cachedEnabledIds));
          issueTypesFetchedRef.current = true;
          return;
        }
      } catch (err) {
        console.error("Error parsing cached issue types:", err);
      }
    }

    fetchAllIssueTypes();
  }, [getIssueTypeList]);

  React.useEffect(() => {
    if (enabledIssueTypeIds.size > 0) {
      console.log("Fetching remote search with enabled IDs ready");
      getIssueTypeRemoteSearch({}).catch((err) => {
        console.error("Failed to fetch issue types:", err);
      });
    }
  }, [enabledIssueTypeIds, getIssueTypeRemoteSearch]);

  React.useEffect(() => {
    getIssueTypeRemoteSearch({}).catch((err) => {
      console.error("Failed to fetch issue types:", err);
    });

    if (actionType !== "create" && subIssueId) {
      setIsLoading(true);
      getSubIssueTypesDetails(subIssueId)
        .catch((err) => {
          console.error("Failed to fetch sub issue details:", err);
          setStatus({
            type: "error",
            message: "Failed to load issue details. Please try again.",
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [
    actionType,
    subIssueId,
    getIssueTypeRemoteSearch,
    getSubIssueTypesDetails,
    setStatus,
  ]);

  React.useEffect(() => {
    if (actionType !== "create") {
      const details = { ...subIssueTypeDetails };

      if (details.conditionsV2 && details.conditionsV2.length > 0) {
        try {
          const formattedConditions = details.conditionsV2.map((condition) => {
            if (condition.key && condition.hasOwnProperty("value")) {
              return condition;
            } else {
              const key = Object.keys(condition)[0];
              return {
                key: key,
                value: condition[key],
              };
            }
          });

          details.conditions = JSON.stringify(formattedConditions);

          setConditionsList(formattedConditions);
        } catch (err) {
          console.error("Error formatting conditionsV2:", err);
          details.conditions = "";
          setConditionsList([]);
        }
      } else {
        details.conditions = "";
        setConditionsList([]);
      }

      details.issueId = details.parentId;
      details.issue = details.issueName;

      setInputFieldState(details);
    }
  }, [subIssueTypeDetails, actionType]);

  React.useEffect(() => {
    if (
      inputFieldState.conditions &&
      typeof inputFieldState.conditions === "string"
    ) {
      try {
        const parsedConditions = JSON.parse(inputFieldState.conditions);
        if (
          Array.isArray(parsedConditions) &&
          JSON.stringify(parsedConditions) !== JSON.stringify(conditionsList)
        ) {
          setConditionsList(parsedConditions);
        }
      } catch (e) {}
    }
  }, [inputFieldState.conditions]);

  const getFilteredIssueTypeList = React.useCallback(
    (filters, pageReq, additionalParams) => {
      return getIssueTypeRemoteSearch(filters).then((response) => {
        console.log("Original response:", response);

        if (response && response.data && enabledIssueTypeIds.size > 0) {
          if (response.data.length > 0) {
            console.log("Sample item from response:", response.data[0]);
          }

          const filtered = response.data.filter((item) => {
            const itemId = String(item.id);

            return enabledIssueTypeIds.has(String(itemId));
          });

          console.log(
            `Filtered from ${response.data.length} to ${filtered.length} items`
          );
          response.data = filtered;
        }

        return response;
      });
    },
    [getIssueTypeRemoteSearch, enabledIssueTypeIds]
  );

  const handleBackClick = () => {
    if (actionType === "create" || actionType === "view") {
      history.push(`/sub-issue-types`);
    } else {
      history.push(`/sub-issue-types/${subIssueId}/view`);
    }
  };

  const checkDisabledField = () => {
    return actionType === "view";
  };

  const handleButtonClick = (action) => {
    if (action === "edit") {
      history.push(`/sub-issue-types/${subIssueId}/edit`);
    } else if (action === "cancel") {
      history.goBack();
    } else if (action === "save") {
      const hasIncompleteCondition = conditionsList.some(
        (condition) =>
          condition.key &&
          (condition.value === "" ||
            (Array.isArray(condition.value) && condition.value.length === 0))
      );

      if (hasIncompleteCondition) {
        setStatus({
          type: "error",
          message:
            "All conditions must have non-empty values. Please complete or remove incomplete conditions.",
        });
        return;
      }
      const missingTranslations = [];
      languages.forEach((lang) => {
        const translation = inputFieldState.vernacularTranslations?.[lang.code];
        if (!translation || translation === "" || translation === "nil") {
          missingTranslations.push(lang.label);
        }
      });
      if (missingTranslations.length > 0) {
        setStatus({
          type: "error",
          message: `Please fill all translations: ${missingTranslations.join(
            ", "
          )}`,
        });
        return;
      }
      inputFieldState.rank = Number(inputFieldState.rank);

      if (inputFieldState.issueId) {
        inputFieldState.issueId = Number(inputFieldState.issueId);
        inputFieldState.parentId = Number(inputFieldState.issueId);
      }
      let validatedState = isValidated(inputFieldState, mandatoryFieldsToCheck);
      if (validatedState === "validated") {
        const conditionsObj = conditionsList.length > 0 ? conditionsList : [];

        const condErrors = validateConditions(conditionsObj);
        if (condErrors.length > 0) {
          setStatus({
            type: "error",
            message: "Conditions validation failed: " + condErrors.join(" "),
          });
          return;
        }

        const payload = { ...inputFieldState };

        payload.conditionsV2 = transformConditionsToV2(conditionsObj);

        try {
          setIsLoading(true);

          saveUpdateSubIssueTypes(actionType, payload)
            .then((res) => {
              if (res) {
                setTimeout(() => {
                  handleBackClick();
                  getSubIssueTypesList(currentPage, activeFilters);
                  setIsLoading(false);
                }, 1000);
              } else {
                setIsLoading(false);
              }
            })
            .catch((err) => {
              setStatus({
                type: "error",
                message: "Failed to save sub issue type. Please try again.",
              });
              setIsLoading(false);
            });
        } catch (err) {
          setStatus({
            type: "error",
            message: "Failed to save sub issue type. Please try again.",
          });
          setIsLoading(false);
        }
      } else {
        setStatus({ type: "error", message: validatedState });
      }
    }
  };

  const handleChange = (key, val) => {
    if (key === "issue") {
      setPriorityFlag(false);

      if (!val) {
        setInputFieldState((prevState) => ({
          ...prevState,
          issueId: null,
          issueName: "",
        }));

        getIssueTypeRemoteSearch({});
        return;
      }

      const selectedIssue = remoteSearch?.issueTypeList?.find(
        (issue) => issue.id === val
      );

      setInputFieldState((prevState) => ({
        ...prevState,
        issueId: val,

        issueName: selectedIssue?.issue || prevState.issueName,
      }));
    } else if (key === "issueName") {
      setInputFieldState((prevState) => ({
        ...prevState,
        issueName: val,

        ...(val === "" ? { issueId: null } : {}),
      }));

      if (val === "") {
        getIssueTypeRemoteSearch({});
      }
    } else if (key === "enabled") {
      setInputFieldState((prevState) => ({
        ...prevState,
        [key]: !prevState.enabled,
      }));
    } else if (key === "conditions") {
      return;
    } else {
      setInputFieldState((prevState) => ({
        ...prevState,
        [key]: val,
      }));
    }
  };

  const getIssueTypeActiveItemById = async (id) => {
    if (remoteSearch && remoteSearch.issueTypeList) {
      for (let i = 0; i < remoteSearch.issueTypeList.length; i++) {
        if (id === remoteSearch.issueTypeList[i].id) {
          return remoteSearch.issueTypeList[i];
        }
      }
    }
    return {};
  };

  const handleTranslationChange = (language, e) => {
    const value = e?.target?.value !== undefined ? e.target.value : e;
    setInputFieldState((prevState) => {
      const currentTranslations = prevState.vernacularTranslations || {};
      return {
        ...prevState,
        vernacularTranslations: {
          ...currentTranslations,
          [language]: value,
        },
      };
    });
  };

  const BreadCrumbBar = () => {
    return (
      <>
        <Back
          onClick={handleBackClick}
          className="mr-10 backBtn"
          color={variables.grey400}
        />
        <Breadcrumb className="sushi-breadcrumbs">
          <Breadcrumb.Link title="Sub Issue Types" onClick={handleBackClick}>
            Sub Issue Types
          </Breadcrumb.Link>
          {actionType === "create" ? (
            <Breadcrumb.Link id="createIssueTypeText">
              new sub-issue types
            </Breadcrumb.Link>
          ) : (
            <>
              <Breadcrumb.Link>{subIssueId}</Breadcrumb.Link>
              <Breadcrumb.Link>{actionType}</Breadcrumb.Link>
            </>
          )}
        </Breadcrumb>
      </>
    );
  };

  const RightActionButtons = () => {
    return actionType === "view" ? (
      <>
        <Permission requiredPerms={[allActions.UPDATE_SUB_ISSUE_TYPE]}>
          <Button
            data-testid="editSubIssueTypeBtn"
            onClick={() => handleButtonClick("edit")}
            className="sushi-btn"
            appearance="outline"
          >
            Edit
          </Button>
        </Permission>
      </>
    ) : (
      <>
        <Button
          data-testid="saveSubIssueTypeBtn"
          className="sushi-btn mr-20"
          onClick={() => handleButtonClick("save")}
        >
          Save
        </Button>
        <Button
          data-testid="cancelSubIssueTypeBtn"
          onClick={() => handleButtonClick("cancel")}
          className="sushi-btn"
          appearance="outline"
        >
          Cancel
        </Button>
      </>
    );
  };

  return (
    <SubIssueTypeActionContainer>
      {isLoading ? (
        <div>Loading sub-issue details...</div>
      ) : (
        <>
          <FlexContainer>
            <LeftContainer justify="flex-start">
              {BreadCrumbBar()}
            </LeftContainer>
            <RightContainer flexpct="25">{RightActionButtons()}</RightContainer>
          </FlexContainer>
          <FieldsContainer border noPadding className="mt-40">
            <FieldsHolder>
              <FieldsSection marginBottom="1.75rem">
                <p className="section-heading">BASIC DETAILS</p>
              </FieldsSection>
              <Input
                value={inputFieldState.name}
                data-testid="subIssueTypeFieldName"
                id="sushi-input"
                onChange={(e) => handleChange("name", e)}
                disabled={checkDisabledField()}
                label="Name"
                innerWidth="40%"
              />
              <Input
                value={inputFieldState.externalMappingName}
                data-testid="subIssueTypeField"
                id="sushi-input"
                onChange={(e) => handleChange("externalMappingName", e)}
                disabled={checkDisabledField()}
                label="External Mapping Name"
                innerWidth="60%"
              />
              {checkDisabledField() ? (
                <Input
                  value={
                    inputFieldState.issueName || inputFieldState.issue || ""
                  }
                  data-testid="subIssueTypeFieldIssueType"
                  id="sushi-input"
                  disabled={true}
                  label="Issue Type"
                  innerWidth="50%"
                />
              ) : (
                <RemoteSearchDropDown>
                  <InfiniteScrollDropdown
                    id="issueTypeInfiniteDropDown"
                    priorityFlag={priorityFlag}
                    getActiveList={getFilteredIssueTypeList}
                    nextPage={remoteSearch.nextPage}
                    resKey="data"
                    keyName="issue"
                    modalState={"Edit"}
                    getOptionLabelOverride={(option) =>
                      option && option.issue
                        ? `${option.issue} (id: ${option.id})`
                        : ""
                    }
                    formatSelectedValue={(item) =>
                      item && item.issue ? item.issue : ""
                    }
                    labelKey="issue"
                    getDataLabelKey="issue"
                    keyTypeToSet="id"
                    label="Issue Type"
                    handleChange={handleChange}
                    activeElement={inputFieldState}
                    getActiveItemById={getIssueTypeActiveItemById}
                    appliedFilters={{}}
                    width="50%"
                    remoteSearchApplicable={true}
                    remoteSearchKey="startswith"
                    defaultVal={
                      inputFieldState.issueName
                        ? {
                            issue: inputFieldState.issueName,
                            id: inputFieldState.issueId,
                          }
                        : ""
                    }
                    showDefaultVal={true}
                    showCross={true}
                    emptySearch={true}
                  />
                </RemoteSearchDropDown>
              )}

              {/* CONDITIONS SECTION */}
              <FieldsSection marginBottom="1.75rem" marginTop="2rem">
                <p className="section-heading">CONDITIONS</p>
              </FieldsSection>

              {conditionsList.map((condition, index) => (
                <ConditionSection key={index}>
                  <p className="sectionHeading">Condition {index + 1}</p>
                  <FlexContainer justify="space-between">
                    <div style={{ width: "90%" }}>
                      <PaginatedReactDropdown
                        options={getFilteredConditionOptions(index)}
                        data-testid={`conditionKeyDropdown-${index}`}
                        labelKey="label"
                        valueKey="key"
                        labelWidth="auto"
                        disabled={checkDisabledField()}
                        value={condition.key}
                        handleChange={(key, val) =>
                          handleConditionChange(index, "key", val)
                        }
                        keyToChange="key"
                        placeholder="Select condition key"
                        showCross={false}
                        id={`conditionKeyDropdown-${index}`}
                        width="50%"
                      />

                      {condition.key && renderValue(condition, index)}
                    </div>

                    {!checkDisabledField() && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CrossCircle
                          onClick={() => handleRemoveCondition(index)}
                          color={variables.grey400}
                          size={20}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    )}
                  </FlexContainer>
                </ConditionSection>
              ))}

              {!checkDisabledField() && (
                <AddConditionContainer justify={"flex-end"}>
                  <div className="flex" onClick={handleAddCondition}>
                    <PlusCircle color={variables.red500} size={20} />
                    <span>
                      Add {conditionsList.length ? "another" : "a"} condition
                    </span>
                  </div>
                </AddConditionContainer>
              )}

              {/* Keep the JSON textarea for advanced editing */}
              <TextAreaWrapper>
                <Textarea
                  id="sushi-textarea"
                  className="sushi-textarea"
                  data-testid="subIssueTypeField"
                  borderColor={variables.primaryColor}
                  innerWidth="80%"
                  resize="none"
                  ref={textareaRef}
                  rows={2}
                  dynamicHeight={false}
                  label="Conditions JSON"
                  onChange={(e) => handleChange("conditions", e)}
                  disabled={true}
                  value={inputFieldState.conditions}
                />
              </TextAreaWrapper>

              <Input
                value={inputFieldState.ticketAttributes}
                data-testid="subIssueTypeField"
                id="sushi-input"
                onChange={(e) => handleChange("ticketAttributes", e)}
                disabled={checkDisabledField()}
                label="Ticket Attributes"
                innerWidth="60%"
              />
              <Input
                value={inputFieldState.rank}
                type="number"
                data-testid="subIssueTypeField"
                id="sushi-input"
                onChange={(e) => handleChange("rank", e)}
                disabled={checkDisabledField()}
                label="Rank"
                innerWidth="30%"
              />
              <ToggleSwitch
                className="text-muted"
                label="Enabled"
                id="sushi-switch"
                size={10}
                spacing={4}
                isActive={inputFieldState.enabled}
                handleChange={() => handleChange("enabled")}
                keyName={`enabled`}
                disabled={checkDisabledField()}
                changeOnState={true}
              />
            </FieldsHolder>
            <Divider height="6px" color={variables.grey100} />
            <FieldsHolder>
              <FieldsSection marginBottom="1.75rem">
                <p className="section-heading">ENTITY TAG</p>
              </FieldsSection>
              <PaginatedReactDropdown
                options={visibilityOptions}
                handleChange={handleChange}
                keyToChange="visibility"
                placeholder="Visibility"
                disabled={checkDisabledField()}
                showCross={true}
                id="subIssueTypeField"
                width="50%"
                labelWidth="auto"
                value={inputFieldState.visibility}
              />
            </FieldsHolder>
            <FieldsHolder>
              <FieldsSection marginBottom="1.75rem">
                <p className="section-heading">Translations</p>
              </FieldsSection>
              {languages.map((lang) => (
                <Input
                  key={lang.code}
                  value={
                    checkDisabledField() &&
                    !inputFieldState.vernacularTranslations?.[lang.code]
                      ? "nil"
                      : inputFieldState.vernacularTranslations?.[lang.code] ||
                        ""
                  }
                  data-testid={`translation${
                    lang.code.charAt(0).toUpperCase() + lang.code.slice(1)
                  }`}
                  id="sushi-input"
                  disabled={checkDisabledField()}
                  onChange={(e) => handleTranslationChange(lang.code, e)}
                  label={lang.label}
                  innerWidth="70%"
                />
              ))}
            </FieldsHolder>
          </FieldsContainer>
        </>
      )}
    </SubIssueTypeActionContainer>
  );
};

const SubIssueTypeActionContainer = styled.section``;
const LeftContainer = styled(FlexContainer)`
  flex: 0 1 30%;
  margin-bottom: ${isMobile() ? "20px" : "unset"};
  & > div {
    flex-direction: ${isMobile() ? "row" : "column"};
  }
`;
const TextAreaWrapper = styled.section`
  margin-bottom: 20px;
  .sushi-textarea {
    white-space: nowrap;
    overflow-x: auto !important;
    overflow-y: hidden;
  }
  textarea {
    white-space: nowrap;
    font-family: monospace;
  }
`;
const RemoteSearchDropDown = styled.section`
  width: 50%;
`;
const RightContainer = styled(FlexContainer)`
  flex: ${({ flexpct }) => (flexpct ? `0 1 ${flexpct}%` : "0 1 35%")};
  justify-content: flex-end;
  .actionDropdown {
    width: 100%;
    margin-bottom: unset;
  }
`;
const FieldsHolder = styled.div`
  padding: 1.875rem;
`;

const ConditionSection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1rem;
    margin-top: 1rem;
    font-size: 12px;
  }
  border-top: 1px solid ${variables.grey200};
  margin-bottom: 20px;
  padding-top: 10px;
`;

const AddConditionContainer = styled(FlexContainer)`
  span {
    color: ${variables.red500};
    font-weight: 500;
    margin-left: 5px;
  }
  margin: 0 1.5rem 1.5rem 0;
  cursor: pointer;
`;
const mapStateToProps = (state) => {
  const { SubIssueTypes, IssueTypes } = state;
  return {
    subIssueTypeDetails: SubIssueTypes.subIssueTypeDetails,
    remoteSearch: IssueTypes.remoteSearch,
    issueTypeList: IssueTypes.issueTypeList,
    currentPage: SubIssueTypes.currentPage,
    activeFilters: SubIssueTypes.activeFilters,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveUpdateSubIssueTypes: bindActionCreators(
      SubIssueTypeActions.saveUpdateSubIssueTypes,
      dispatch
    ),
    getSubIssueTypesDetails: bindActionCreators(
      SubIssueTypeActions.getSubIssueTypesDetails,
      dispatch
    ),
    getIssueTypeRemoteSearch: bindActionCreators(
      SubIssueTypeActions.getIssueTypeRemoteSearch,
      dispatch
    ),
    getSubIssueTypesList: bindActionCreators(
      SubIssueTypeActions.getSubIssueTypesList,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getIssueTypeList: bindActionCreators(
      IssueTypesActions.getIssueTypeList,
      dispatch
    ),
    getIssueArea: bindActionCreators(IssueTypesActions.getIssueArea, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SubIssueTypeAction);
